var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "111.535 99.746 10 11.531",
    width: "10px",
    height: "11.531px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 115.91 111.277 C 114.65 111.121 113.606 110.572 112.778 109.629 C 111.949 108.686 111.535 107.58 111.535 106.309 C 111.535 105.621 111.671 104.962 111.942 104.332 C 112.213 103.702 112.598 103.152 113.098 102.684 L 113.989 103.574 C 113.593 103.928 113.293 104.34 113.09 104.809 C 112.887 105.277 112.785 105.777 112.785 106.309 C 112.785 107.225 113.077 108.035 113.66 108.738 C 114.244 109.442 114.994 109.871 115.91 110.027 L 115.91 111.277 Z M 117.16 111.277 L 117.16 110.027 C 118.067 109.861 118.814 109.428 119.403 108.731 C 119.991 108.033 120.285 107.225 120.285 106.309 C 120.285 105.267 119.921 104.382 119.192 103.652 C 118.463 102.923 117.577 102.559 116.535 102.559 L 116.489 102.559 L 117.176 103.246 L 116.301 104.121 L 114.114 101.934 L 116.301 99.746 L 117.176 100.621 L 116.489 101.309 L 116.535 101.309 C 117.931 101.309 119.114 101.793 120.082 102.762 C 121.051 103.731 121.535 104.913 121.535 106.309 C 121.535 107.569 121.121 108.671 120.293 109.613 C 119.465 110.556 118.421 111.111 117.16 111.277 Z",
    fill: "#1C1B1F",
    id: "object-0",
    transform: "matrix(1, 0, 0, 1, -1.7763568394002505e-15, 7.105427357601002e-15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.f5483e813a7fa1df3726728f01a33c2f.svg";
export { ForwardRef as ReactComponent };